import React from 'react';
import PropTypes from 'prop-types';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import GoogleLogin from 'react-google-login';

import AppleLoginButton from '../buttons/AppleLoginButton';
import FacebookLoginButton from '../buttons/FacebookLoginButton';
import GoogleLoginButton from '../buttons/GoogleLoginButton';
import baseStyles from '../../../styles/baseStyles.module.scss';
import styles from './styles/styles.module.scss';
import { ProPageStrings } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  altLoginsText: { appleLogin, facebookLogin, googleLogin }
} = ProPageStrings;

const AltLoginsForm = ({ appleLoginHandler, facebookLoginHandler, googleLoginHandler, googleClientId, facebookAppId }) => {
  return (
    <div className={baseStyles.section}>
      <GoogleLogin
        clientId={googleClientId}
        render={renderProps => (
          <div className={styles.item}>
            <GoogleLoginButton text={googleLogin} handler={renderProps.onClick} />
          </div>
        )}
        buttonText="Login"
        onSuccess={googleLoginHandler}
        // don't send onFailure to Bugsnag, these are expected events like popup_closed_by_user
        cookiePolicy="single_host_origin"
      />
      <FacebookLogin
        disableMobileRedirect
        appId={facebookAppId}
        autoLoad
        callback={facebookLoginHandler}
        scope="email,user_friends,user_gender,user_birthday,user_location"
        render={renderProps => (
          <div className={styles.item} onClick={renderProps.onClick}>
            <FacebookLoginButton text={facebookLogin} handler={facebookLoginHandler} />
          </div>
        )}
      />
      <div className={styles.item}>
        <AppleLoginButton text={appleLogin} handler={appleLoginHandler} />
      </div>
    </div>
  );
};

AltLoginsForm.propTypes = {
  appleLoginHandler: PropTypes.func.isRequired,
  facebookLoginHandler: PropTypes.func.isRequired,
  googleLoginHandler: PropTypes.func.isRequired,
  facebookAppId: PropTypes.number.isRequired,
  googleClientId: PropTypes.string.isRequired
};

export default AltLoginsForm;
